"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Checks if the given element is on the screen.
 *
 * @param {Element} el The element.
 * @param {boolean} partial Whether to consider the element visible when only a
 *   part of it is on the screen.
 *
 * @returns {boolean} Whether the element is visible.
 */
function checkVisibility(el, partial) {
  if (!el) {
    return false;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      right = _el$getBoundingClient.right,
      bottom = _el$getBoundingClient.bottom,
      left = _el$getBoundingClient.left,
      width = _el$getBoundingClient.width,
      height = _el$getBoundingClient.height;

  if (top + right + bottom + left === 0) {
    return false;
  }

  var topCheck = partial ? top + height : top;
  var bottomCheck = partial ? bottom - height : bottom;
  var rightCheck = partial ? right - width : right;
  var leftCheck = partial ? left + width : left;
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  return topCheck >= 0 && leftCheck >= 0 && bottomCheck <= windowHeight && rightCheck <= windowWidth;
}

var _default = checkVisibility;
exports["default"] = _default;